import { useCallback } from 'react';
import { useTourDispatch } from '../../hooks';
import { setIsShowingDimensionPanel } from '../../store';

interface Props {
  uuid: string;
}

type ReturnType = {
  closeDimensionsPanel: () => void;
};

const useDimensions = ({ uuid }: Props): ReturnType => {
  const dispatch = useTourDispatch();

  const closeDimensionsPanel = useCallback(() => {
    dispatch(
      setIsShowingDimensionPanel({
        uuid,
        isShowingDimensionPanel: false,
      })
    );
  }, [dispatch, uuid]);

  return {
    closeDimensionsPanel,
  };
};

export default useDimensions;
